import { render } from "./FilterAndSearch.vue?vue&type=template&id=561926a3&ts=true"
import script from "./FilterAndSearch.vue?vue&type=script&lang=ts"
export * from "./FilterAndSearch.vue?vue&type=script&lang=ts"

import exportComponent from "/codebuild/output/src1243766806/src/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__